import { render, staticRenderFns } from "./videoFrame.vue?vue&type=template&id=0c4f1eac"
import script from "./videoFrame.vue?vue&type=script&lang=js"
export * from "./videoFrame.vue?vue&type=script&lang=js"
import style0 from "./videoFrame.vue?vue&type=style&index=0&id=0c4f1eac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports